import Dates from '../Dates/Dates';

/**
 * Získá datum z tlačítka kalendáře a naformátuje ho pro URL.
 * @param {object} date {dateFrom, dateTo, interval}
 * @return {string}
 */
export default function getDateForUrl(date) {
	const calendarButton = document.getElementById('CalendarButton');

	if (!date) {
		if (calendarButton) {
			const dateFrom = Dates.stringToTimestamp(calendarButton.querySelector('.Calendar-dateFrom').innerText);

			const dateTo = Dates.stringToTimestamp(calendarButton.querySelector('.Calendar-dateTo').innerText);

			date = {
				dateFrom: Dates.timestampToAPIFormat(dateFrom),
				dateTo: Dates.timestampToAPIFormat(dateTo),
				interval: calendarButton.getAttribute('data-calendar-period-option'),
			};
		} else {
			return '';
		}
	}

	return 'dateStart=' + date.dateFrom + '&dateFinish=' + date.dateTo + '&interval=' + date.interval;
}
